import { toast } from "react-toastify";

export async function stakeNFT(data) {
    try {
        return window.location.href = data.stakeLink;
    } catch (e) {
        toast.error(e?.message);
    }
}
